import { render } from "./fchb.vue?vue&type=template&id=4a6640ce&scoped=true&ts=true"
import script from "./fchb.vue?vue&type=script&lang=ts"
export * from "./fchb.vue?vue&type=script&lang=ts"

import "./fchb.vue?vue&type=style&index=0&id=4a6640ce&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6640ce"]])

export default __exports__